import { Timestamp } from 'firebase/firestore';

// Matches iOS Notification.NotificationType raw values
export enum NotificationType {
  GENERAL = 'general',
  EMERGENCY = 'emergency',
  MAINTENANCE = 'maintenance',
  UPDATE = 'update',
  CHAT = 'chat'
}

export interface AppNotification {
  id: string;
  title: string;
  message: string;
  type: NotificationType;
  timestamp: Date;
  sentBy: string;
  isRead: boolean;
  readBy: Record<string, boolean>;
  imageURL?: string;
  imageCaption?: string;
  targetUserId?: string;
  pinId?: string;
  commenterId?: string;
}

export interface NotificationDocumentData {
  title: string;
  message: string;
  type: string;
  timestamp: Date | Timestamp;
  sentBy: string;
  isRead: boolean;
  readBy?: Record<string, boolean>;
  imageURL?: string;
  imageCaption?: string;
  targetUserId?: string;
  pinId?: string;
  commenterId?: string;
}

export const NOTIFICATION_TYPE_INFO: Record<NotificationType, { displayName: string; emoji: string; color: string }> = {
  [NotificationType.GENERAL]: { displayName: 'General', emoji: '🔔', color: '#007aff' },
  [NotificationType.EMERGENCY]: { displayName: 'Emergency', emoji: '⚠️', color: '#ff3b30' },
  [NotificationType.MAINTENANCE]: { displayName: 'Maintenance', emoji: '🔧', color: '#ff9500' },
  [NotificationType.UPDATE]: { displayName: 'App Update', emoji: '⬇️', color: '#34c759' },
  [NotificationType.CHAT]: { displayName: 'New Comment', emoji: '💬', color: '#9c27b0' }
};

export class AppNotificationModel {
  static fromFirestore(id: string, data: NotificationDocumentData): AppNotification {
    return {
      id,
      title: data.title,
      message: data.message,
      type: (data.type as NotificationType) || NotificationType.GENERAL,
      timestamp: data.timestamp instanceof Timestamp ? data.timestamp.toDate() : new Date(data.timestamp),
      sentBy: data.sentBy,
      isRead: data.isRead ?? false,
      readBy: data.readBy ?? {},
      imageURL: data.imageURL,
      imageCaption: data.imageCaption,
      targetUserId: data.targetUserId,
      pinId: data.pinId,
      commenterId: data.commenterId
    };
  }

  static hasUserRead(notification: AppNotification, userId: string): boolean {
    return notification.readBy[userId] ?? false;
  }

  static isRecent(notification: AppNotification): boolean {
    return Date.now() - notification.timestamp.getTime() < 24 * 60 * 60 * 1000;
  }
}
